"use strict";

exports.__esModule = true;
exports.default = exports.sortGroups = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ErrorMessage = _interopRequireDefault(require("../../ErrorMessage"));

var _Group = _interopRequireDefault(require("../Group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortGroups = function sortGroups(a, b) {
  if (a === b) {
    return 0;
  }

  return a < b ? -1 : 1;
};

exports.sortGroups = sortGroups;

var GroupList = function GroupList(_ref) {
  var groups = _ref.groups,
      toggleUsers = _ref.toggleUsers,
      onItemClick = _ref.onItemClick,
      filter = _ref.filter,
      GA = _ref.GA;
  var filtered = Object.keys(groups).filter(function (key) {
    return key.toLowerCase().includes(filter.toLowerCase());
  }); // If we have employees with no group

  var noGroupIndex = filtered.findIndex(function (item) {
    return item === 'No group';
  });

  if (noGroupIndex > -1) {
    filtered.splice(noGroupIndex, 1);
  }

  filtered.sort(sortGroups);

  if (noGroupIndex > -1) {
    filtered.push('No group');
  }

  var groupArray = filtered.map(function (key) {
    return _react.default.createElement(_Group.default, {
      GA: GA,
      key: key,
      title: key,
      users: groups[key],
      onClick: onItemClick,
      toggleUsers: toggleUsers
    });
  });
  return _react.default.createElement(_react.default.Fragment, null, groupArray.length ? groupArray : _react.default.createElement(_ErrorMessage.default, null, "No results found"));
};

GroupList.displayName = 'GroupList';
GroupList.propTypes = {
  GA: (0, _propTypes.shape)({
    category: _propTypes.string
  }).isRequired,
  groups: (0, _propTypes.shape)({}).isRequired,
  toggleUsers: _propTypes.func.isRequired,
  onItemClick: _propTypes.func.isRequired,
  filter: _propTypes.string
};
GroupList.defaultProps = {
  filter: ''
};
var _default = GroupList;
exports.default = _default;